import { InjectionToken } from '@angular/core';

export const CONTEXT_ORGANIZATION_KEY = new InjectionToken<string>('CONTEXT_ORGANIZATION_KEY');
export const CONTEXT_USER_ID = new InjectionToken<string>('CONTEXT_USER_ID');

export * from './lib/stores';
